// 网站基础配置
export const siteConfig = {
    // API配置
    api: {
        // API基础地址
        apiBaseUrl: process.env.REACT_APP_API_BASE_URL,  // 从环境变量中读取API地址
        // API超时时间（毫秒）
        timeout: 10000
    },
    // 网站基本信息
    site: {
        title: process.env.REACT_APP_SITE_TITLE || '快马加鞭管理系统2.0',
        logo: process.env.REACT_APP_SITE_LOGO || '/kmjb_logo.jpg',
        shortName: process.env.REACT_APP_SITE_SHORT_NAME || '快马加鞭'
    },

    // 主题配置
    theme: {
        primaryColor: '#0077fa',
        secondaryColor: '#6c757d'
    },

    // 布局配置
    layout: {
        // 导航栏配置
        nav: {
            defaultCollapsed: false,
            secondaryNavDefaultCollapsed: false
        }
    },

    // 系统功能配置
    features: {
        // 登录配置
        login: {
            // 模拟登录延迟时间(毫秒)
            mockDelay: 1000
        },
        // 注册配置
        register: {
            // 模拟注册延迟时间(毫秒)
            mockDelay: 1000,
            // 是否启用注册功能
            enabled: true
        }
    }
};